import { SWAP_STATUSES } from 'entities/swaps';

import { EFilterEntity, EFilterFormatter, IFilterSchemeExtended } from '../common';

export const dexPairSwapsFiltersScheme = (): Record<string, IFilterSchemeExtended> => {
  return {
    wallets: {
      type: EFilterEntity.multi_search,
      label: 'Wallets',
      name: 'wallets',
      field: 'wallets',
      single: true,
    },
    statuses: {
      type: EFilterEntity.colors_multi_select,
      formatter: EFilterFormatter.colors_multi_select,
      label: 'Statuses',
      name: 'statuses',
      field: 'statuses',
      listMultiColors: SWAP_STATUSES,
      single: true,
    },
  };
};
